import axios from "axios";

const API_BASE = "https://www.frendrops.in/api";

export const addToCart = async (productId, quantity = 1, deliveryDate) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const payload = {
    product_id: productId,
    quantity: Number(quantity) || 1,
    ...(deliveryDate ? { delivery_date: deliveryDate } : {}),
  };

  // Shreephool live branch prefers /cart/add and falls back to /add-to-cart.
  try {
    return await axios.post(`${API_BASE}/cart/add`, payload, config);
  } catch (error) {
    if (error?.response?.status !== 404) throw error;
    return axios.post(`${API_BASE}/add-to-cart`, payload, config);
  }
};

export const setCartQuantity = async (productId, quantity, deliveryDate) => {
  const token = localStorage.getItem("token");
  return axios.post(
    `${API_BASE}/add-to-cart`,
    {
      product_id: productId,
      quantity: Number(quantity) || 0,
      ...(deliveryDate ? { delivery_date: deliveryDate } : {}),
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
